import { apiPath } from "constants/constants";
import { config } from "config/config";
import { useEffect, useState } from "react";
import useHashConnect from "./useHashConnect";

export default function useExchangeRate() {
  const { tvl } = useHashConnect();
  const [exchangeRate, setExchangeRate] = useState<number | undefined>(
    undefined
  );
  const [error, setError] = useState<boolean>(false);

  let isFirstTime = true;

  const updateExchangeRate = async () => {
    try {
      const resp: any = await fetch(
        `${config.network.url}${apiPath}tokens/${config.ids.tokenId}`
      );
      const response = await resp.json();
      if (response?.total_supply) {
        setError(false);
        if (tvl != 0 && response.total_supply != 0) {
          setExchangeRate(response.total_supply / tvl);
        }
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
  };

  useEffect(() => {
    if (tvl > 0) {
      setTimeout(
        () => {
          isFirstTime = false;
          updateExchangeRate();
        },
        isFirstTime ? 0 : 10000
      );
    }
  }, [tvl]);

  return { exchangeRate, updateExchangeRate, error };
}
